import React, { useEffect, useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import GeneralInfo from './GeneralInfo';
import CompanyInfo from './CompanyInfo';
import Integration from './Integration';
import Documents from './Documents';
import Branding from './Branding';

import { handleGetRequest } from '../../service/GetTemplate';
import { endPoints } from '../../Config';
import { useLocation } from 'react-router-dom';

const Profile = () => {
    const location = useLocation();
    const [activeIndex, setActiveIndex] = useState(0);
    const [profileInfo, setProfileInfo] = useState(null);

    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const merchantId = user?.data?.merchantId;

    // ✅ HANDLE TAB FROM URL (HashRouter Fix)
    useEffect(() => {
        const hash = window.location.hash; 
        // Example: #/profile?tab=documents

        if (hash.includes('?')) {
            const queryString = hash.split('?')[1]; // tab=documents
            const params = new URLSearchParams(queryString);
            const tab = params.get('tab');

            if (tab === 'documents') setActiveIndex(3);
            if (tab === 'integration') setActiveIndex(2);
            if (tab === 'company') setActiveIndex(1);
            if (tab === 'branding') setActiveIndex(4);
        }
    }, [location]);

    // ✅ FETCH PROFILE INFO
    const getProfileInfo = async () => {
        const response = await handleGetRequest(endPoints.getProfileInfo(merchantId), true);
        if (response) {
            setProfileInfo(response?.data);
        }
    };

    useEffect(() => {
        if (merchantId) {
            getProfileInfo();
        }
    }, [merchantId]);

    return (
        <div className="p-4">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>Profile</h3>
            </div>

            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>

                <TabPanel header="POC Info" leftIcon="pi pi-home mr-2">
                    <GeneralInfo profileInfo={profileInfo} />
                </TabPanel>

                <TabPanel header="Company Info" leftIcon="pi pi-info-circle mr-2">
                    <CompanyInfo profileInfo={profileInfo} />
                </TabPanel>

                <TabPanel header="Integration" leftIcon="pi pi-cog mr-2">
                    <Integration />
                </TabPanel>

                <TabPanel header="Documents" leftIcon="pi pi-images mr-2">
                    <Documents />
                </TabPanel>

                <TabPanel header="Branding" leftIcon="pi pi-images mr-2">
                    <Branding />
                </TabPanel>

            </TabView>
        </div>
    );
};

export default Profile;
